module.exports = __webpack_public_path__ + "static/img/mpdpBottom2.8f26b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mpdpBottom2.png
// module id = +URz
// module chunks = 2